import React, {useContext, useEffect, useRef, useState} from 'react';
import UserContext from '../../common/UserContext.js';

// kendo react
import {Loader} from '@progress/kendo-react-indicators';
import {Popover} from '@progress/kendo-react-tooltip';

// multilingual
import {useLocalization} from "@progress/kendo-react-intl";
import {
    notGeneratedAvailableRedeemV2Key,
    genericErrorTitleKey,
    mainMessages,
    notGeneratedSupportAgentV2Key
} from '../../../assets/text/MultilingualText.js';
import {Col, Row} from "reactstrap";
import {downloadLicenses} from "../../common/utilities";
import {DownloadIcon, WarningErrorIcon} from "../../common/icons";
import KSMPopover from "../../common/Popovers";


// download cell for standalone renewal grid
export const DownloadPanelBarHeader = (props) => {
    const {
        panelBarTitle,
        index,
        renewalLicenses,
        setIsLoading,
        handleBeforeUnload
    } = props;
    const {
        accessToken
    } = useContext(UserContext);

    const anchor = useRef(null);
    const [showPopover, setShowPopover] = useState(false);
    const [downloadIcon, setDownloadIcon] = useState("loading");
    const [transactionID, setTransactionID] = useState("");

    //Show popover if there is an error on mouse over
    const onMouseOver = (ev) => {
        setShowPopover(true);
    };

    //Remove popover on mouse leave
    const onMouseOut = (ev) => {
        let isChildEl = ev.currentTarget.contains(ev.relatedTarget);
        if (!isChildEl) setShowPopover(false);
    };

    // update panel bar download icon and transaction id
    useEffect(() => {
        setDownloadIcon(renewalLicenses[index]['download_icon']);
        setTransactionID([renewalLicenses[index]['transaction_id']]);
    }, [renewalLicenses]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div
                className={"k-h5"}
                style={{
                    color: 'white',
                    margin: '0 0 0 2px',
                }}
            >
                <Row
                    style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <Col
                        style={{
                            flex: '0 0 auto',
                            width: 'auto'
                        }}
                    >
                        <div
                            className={"k-h5"}
                            style={{
                                color: 'white',
                                margin: '0'
                            }}
                        >
                            {panelBarTitle}
                        </div>
                    </Col>
                    <Col/>
                    <Col>
                        <div
                            style={{
                                float: 'right'
                            }}
                        >
                            <div>
                                {downloadIcon === "none" && <></>}
                                {downloadIcon === "loading" && <Loader
                                    type={'pulsing'}
                                    style={{
                                        color: '#FFFFFF'
                                    }}
                                />}
                                {downloadIcon === "download" &&
                                    <span
                                        onClick={() => {
                                            downloadLicenses(transactionID, accessToken, setIsLoading, handleBeforeUnload);
                                        }}
                                    >
                                        <DownloadIcon
                                            size={'medium'}
                                            style={{
                                                color: 'white',
                                                marginTop: '0.35rem',
                                                marginLeft: '0.35rem',
                                                marginRight: '0.35rem',
                                                cursor: 'pointer'
                                            }}
                                        />
                                    </span>
                                }
                                {(downloadIcon === "error" || downloadIcon === "support-agent-error") &&
                                    <span
                                        onMouseOver={onMouseOver}
                                        onMouseOut={onMouseOut}
                                    >
                                    <DownloadErrorPopover
                                        downloadIcon={downloadIcon}
                                        showPopover={showPopover}
                                        anchor={anchor}
                                    />
                                    <span ref={anchor}>
                                        <WarningErrorIcon
                                            size={'medium'}
                                            style={{
                                                color: 'var(--keysight-pink)',
                                                marginTop: '0.35rem',
                                                marginLeft: '0.35rem',
                                                marginRight: '0.35rem',
                                            }}
                                        />
                                    </span>
                                </span>}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const DownloadErrorPopover = (props) => {
    const {
        downloadIcon,
        showPopover,
        anchor
    } = props
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    let title;
    let message;

    if (downloadIcon === "support-agent-error") {
        title = localization.toLanguageString(
            genericErrorTitleKey,
            mainMessages[siteLanguageDefault][genericErrorTitleKey]
        );
        message = localization.toLanguageString(
            notGeneratedSupportAgentV2Key,
            mainMessages[siteLanguageDefault][notGeneratedSupportAgentV2Key]
        );
    } else {
        title = localization.toLanguageString(
            genericErrorTitleKey,
            mainMessages[siteLanguageDefault][genericErrorTitleKey]
        );
        message = localization.toLanguageString(
            notGeneratedAvailableRedeemV2Key,
            mainMessages[siteLanguageDefault][notGeneratedAvailableRedeemV2Key]
        );
    }

    return (
        <KSMPopover
            show={showPopover}
            anchor={anchor.current}
            position={'left'}
            type={'error'}
            message={<div>
                <b>{title}</b>
                <br/>
                {message}
            </div>}
        />
    )
}